import banner1 from '../../assets/images/banner1.png';
import banner2 from '../../assets/images/banner2.png';
import banner3 from '../../assets/images/banner3.png';
import banner4 from '../../assets/images/banner4.png';
import banner5 from '../../assets/images/banner5.png';


const Productos = () => {
    return (
        <div className="flex mt-10 w-full overflow-hidden gap-3">
            <img src={banner1} alt="Imagen 1" className='w-full md:w-auto'/>
            <div className='flex-grow md:flex flex-col gap-3 hidden'>
                <div className='flex w-full gap-3'>
                    <img src={banner2} alt="Imagen 2" />
                    <img src={banner3} className='flex-grow' alt="Imagen 3" />
                </div>
                <div className='flex gap-3'>
                    <img src={banner4} className='flex-grow' alt="Imagen 4" />
                    <img src={banner5} alt="Imagen 5" />
                </div>
            </div>
        </div>
    )
}

export default Productos;